import React, { useEffect } from 'react';
import { ListBenefitsCallToAction } from './ListBenefitsCallToAction/ListBenefitsCallToAction';
import { ListBenefitsDetails } from './ListBenefitsDetails/ListBenefitsDetails';

const ListBenefits = () => {

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('list-benefits.ready'); }, []);

  return (
    <>
      <div className="sui-grid sui-grid-cols-1 sui-gap-3 sui-m-3" data-component="ListBenefits">
        <ListBenefitsCallToAction />
        <ListBenefitsDetails />
      </div>
    </>
  );
};

ListBenefits.displayName = 'ListBenefits';

export { ListBenefits };
